import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/images/logo_top.png'
import _imports_1 from '@/assets/images/logout_icon.png'
import _imports_2 from '@/assets/images/logo_top.png'


const _hoisted_1 = { class: "title_bar" }
const _hoisted_2 = { class: "menu_ul" }
const _hoisted_3 = { class: "title_menu_ul" }
const _hoisted_4 = { class: "title_menu" }
const _hoisted_5 = { class: "title_menu" }
const _hoisted_6 = { class: "contents" }
const _hoisted_7 = { class: "main_container" }
const _hoisted_8 = { class: "footer_menu_div" }
const _hoisted_9 = { class: "footer_menu_ul" }

import loginAPI from "@/api/loginAPI";
import { userStore } from "@/store/userStore";
import { onMounted,  } from "vue";
import { useRouter, onBeforeRouteLeave } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainView',
  setup(__props) {

const router = useRouter();
const store = userStore();

onBeforeRouteLeave((to, from, next) => {
  console.log(to,from,"to,from");
  // Skip the check if already navigating to certificateApproval to prevent loops
  if (to.name === 'certificateApproval') {
    next();
    return;
  }
  
  if (store.isLogin && store.userInfo.가입상태 === '신청') {
    if(to.name === "announce" || to.name === "mypage" || to.name === "resourceBoard") {    
      next({ name: "certificateApproval" });
    } else {
      next();
    }
  } else {
    next();
  }
});
onMounted(() => {
  if (router.currentRoute.value.name == "main") {
    router.push({ name: "home" });
  } 
  if(store.userInfo.가입상태 == '신청') {
    router.push({ name: "certificateApproval" });
  }
});

const goPage = (page: string) => {
  if (page === "announce" || page === "mypage" || page === "resourceBoard") {
    if (store.isLogin == false) {
      alert("로그인 후 이용하실 수 있습니다.");
      router.push({ name: "login" });
      return;
    } else {
      if(store.userInfo.가입상태 === '신청') {
        alert("가입승인 후 이용하실 수 있습니다.");
        router.push({ name: "certificateApproval" });
        return;
      }
      window.scrollTo({ top: 0, behavior: "auto" });
      router.push({ name: page });
      return;
    }
  }
  window.scrollTo({ top: 0, behavior: "auto" });
  router.push({ name: page });
};

const logout = () => {
  if (window.confirm("로그아웃 하시겠습니까?")) {
    loginAPI.logout().then(() => {
      store.logout();
      router.push({ name: "home" });
    });
  }

  // router.push({ name: "home" });
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "title_logo",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goPage('home')))
        }, _cache[10] || (_cache[10] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "logo"
          }, null, -1)
        ])),
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", {
            class: "menu_li",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (goPage('notice')))
          }, "공지사항"),
          _createElementVNode("li", {
            class: "menu_li",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (goPage('announce')))
          }, "공고관리"),
          _createElementVNode("li", {
            class: "menu_li",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (goPage('mypage')))
          }, "마이페이지"),
          _createElementVNode("li", {
            class: "menu_li",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (goPage('resourceBoard')))
          }, "자료실")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (!_unref(store).isLogin)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: "title_menu_li",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (goPage('login')))
                }, "로그인"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (!_unref(store).isLogin)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: "title_menu_li",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (goPage('signup')))
                }, "회원가입"))
              : _createCommentVNode("", true)
          ]),
          (_unref(store).isLogin)
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: "title_menu_li",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (logout()))
              }, _cache[11] || (_cache[11] = [
                _createElementVNode("img", { src: _imports_1 }, null, -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_view)
      ]),
      _createElementVNode("footer", null, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", {
              class: "footer_menu_li",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (goPage('termsOfService')))
            }, "이용약관"),
            _createElementVNode("li", {
              class: "footer_menu_li",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (goPage('privacyPolicy')))
            }, "개인정보취급방침")
          ])
        ]),
        _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"footer_box\"><div><img src=\"" + _imports_2 + "\" alt=\"\"></div><div id=\"copyright\"><div class=\"copyright_text\"> 주식회사 파트너전자입찰시스템  |  사업자번호 : 844-86-02440  |  통신판매업 : 제2022-서울마포-2662호<br> 주소 : 서울특별시 마포구 성암로 189, 1606호(상암동, 중소기업 DMC타워)<br><span class=\"str\">대표전화 : 02-376-9990</span>  |  <span class=\"str\">팩스 : 02-376-9989</span>  |  이메일 : ptbid@naver.com <div>Copyright ⓒ 2022~ 주식회사 파트너전자입찰시스템 All rights reserved</div></div><a href=\"javascript:scrollTop();\" class=\"btn_footer_top\"></a></div></div>", 1))
      ])
    ])
  ], 64))
}
}

})